import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { Role } from '../enums/role';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = authService.user();

  if (!user?.token) {
    router.navigate(['/auth/login']);
    return false;
  }

  if (user.role === Role.ADMIN) {
    return true;
  }

  router.navigate(['/search']);
  return false;
};
